import React from "react";
import { ContactForm } from "./ContactForm";
import * as Kontakt from "../style/KontaktaOss-style";

export const KontaktaOss = () => {
  return (
		<Kontakt.OuterContactContainer id="kontakt">
			<Kontakt.ContactWrapper>
				<Kontakt.TextWrapper>
					<Kontakt.ContactH1>Säg hej!</Kontakt.ContactH1>
					<Kontakt.ContactH3>
						{`Är du lika nyfiken på oss som vi är på dig? 
        Hör av dig till oss om du har en idé, ett projekt du vill ha hjälp med eller är nyfiken på oss.`}
					</Kontakt.ContactH3>
				</Kontakt.TextWrapper>
				<Kontakt.InfoWrapper>
					<Kontakt.ContactContainer>
						<Kontakt.StyledEmailIcon />
						<Kontakt.ContactInfo
							href="mailto:hello@andtech.se"
							aria-label="Send an email to info@andtech.se">
							hello@andtech.se
						</Kontakt.ContactInfo>
					</Kontakt.ContactContainer>
					<Kontakt.ContactContainer>
						<Kontakt.StyledPhoneIcon />
						<Kontakt.ContactInfo
							href="tel:+46701234567"
							aria-label="Call 070 341 42 88">
							070 341 42 88
						</Kontakt.ContactInfo>
					</Kontakt.ContactContainer>
					<Kontakt.ContactContainer>
						<Kontakt.StyledAdressIcon />
						<Kontakt.AdressContactInfo>
							Bondegatan 30
							<br />
							11633 Stockholm
						</Kontakt.AdressContactInfo>
					</Kontakt.ContactContainer>
					<Kontakt.ContactContainer>
						<Kontakt.StyledLinkedinIcon />
						<Kontakt.ContactInfo
							href="https://www.linkedin.com/company/andtech-ab/posts/?feedView=all"
							aria-label="Let's connect on Linkedin">
							Linkedin
						</Kontakt.ContactInfo>
					</Kontakt.ContactContainer>
				</Kontakt.InfoWrapper>
				<ContactForm />
			</Kontakt.ContactWrapper>
		</Kontakt.OuterContactContainer>
	);
};